import { c as _c } from "react/compiler-runtime";
import type { Outcome } from '@svs/nova-poolbetting/schema/coupon';
import type { ReactNode } from 'react';
type GameAnalysisTitleProps = {
  eventAnalyses?: {
    eventOutcome: (Outcome | undefined)[];
    authorName: string;
  }[];
};
const getEndName = (authorName: string): string => {
  const lastChar = authorName.slice(-1).toLowerCase();
  if (lastChar === 's' || lastChar === 'x' || lastChar === 'z') {
    return `${authorName}'`;
  }
  return `${authorName}s`;
};

/**
 * Game analysis title component.
 *
 * @param root0 props
 * @param root0.eventAnalyses event analyses outcomes and author names
 * @returns game analysis title component
 */
export function GameAnalysisTitle(t0) {
  const $ = _c(3);
  const {
    eventAnalyses
  } = t0;
  if (!eventAnalyses) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span>För tillfället har vi inga speltips</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== eventAnalyses) {
    t1 = eventAnalyses.map(_temp);
    $[1] = eventAnalyses;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(eventAnalys, index) {
  return <span className="min-h-7.5" key={index}>{getEndName(eventAnalys.authorName)} speltips</span>;
}